import { apiSlice } from "./apiSlice";
import { VENDORS_URL } from "../../../../../constants";

export const vendorApiSlice = apiSlice.injectEndpoints({
    endpoints : (builder) => ({
        getVendors : builder.query({
            query: () => {
                return {
                    url: VENDORS_URL
                };
            },
        }) 
    })
})

export const {useGetVendorsQuery} = vendorApiSlice;